'use strict';

const angular = require('angular');

module.exports = angular.module('spinnaker.core.pipeline.stage.bake', [
  require('./bakeStage').name,
  require('./modal/addExtendedAttribute.controller.modal').name
]);



// WEBPACK FOOTER //
// ./app/scripts/modules/core/src/pipeline/config/stages/bake/bakeStage.module.js